import React from "react";
import { EmailAddressesPage } from "./EmailAddressesPage";

const EmailAddresses = () => {
	return <EmailAddressesPage />;
};

export default EmailAddresses;
